<button
  vs-button
  type="button"
  [appearance]="appearance"
  [theme]="theme"
  [size]="size"
  [disabled]="disabled || generating"
  [ngClass]="['flex items-center gap-2', buttonClass || '']"
  (click)="onClick($event)"
  [attr.aria-busy]="generating"
>
  <ng-container *ngIf="!generating; else loading">
    <vs-icon *ngIf="icon" [name]="icon"></vs-icon>
    <span>{{ label }}</span>
  </ng-container>
</button>

<ng-template #loading>
  <span class="flex items-center gap-2">
    <vs-icon [name]="loadingIcon" class="animate-spin"></vs-icon>
    <span>{{ generatingLabel }}</span>
  </span>
</ng-template>
